export default __webpack_public_path__ + "static/media/1424.04d5e1e7.jpg";